import {
  ContractIcon,
  PeopleIcon,
  UserSquareIcon,
  PencilIcon,
} from "components/Icons/linear";
import { PersonIcon } from "components/Icons";
import { FormattedMessage as FM } from "react-intl";

const STYLE_ICON = "size-7 md:size-7 fill-current text-white";

const Icon = {
  default: <UserSquareIcon className={STYLE_ICON} />,
  user: <PersonIcon className={STYLE_ICON} />,
  people: <PeopleIcon className={STYLE_ICON} />,
  contract: <ContractIcon className={STYLE_ICON} />,
  pencil: <PencilIcon className={STYLE_ICON} />,
};

function Sections({ title, children, icon }) {
  return (
    <section className="bg-white p-4 md:p-8 rounded-2xl shadow-md">
      <div>
        <div className="flex space-x-2 mb-2 md:x-3 md:mb-4  items-center">
          <span>{Icon[icon] ?? Icon.default}</span>
          <h1 className="text-sm md:text-2xl font-semibold tablet:text-base">
            <FM id={title} />
          </h1>
        </div>
        <div>{children}</div>
      </div>
    </section>
  );
}

export default Sections;
